/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

/**
 * Entra em modo tela cheia para o elemento especificado
 * @param element - Elemento HTML para entrar em tela cheia
 */
export const handleEnterFullscreen = (element: HTMLElement | null) => {
  if (!element) {
    console.warn('Elemento não encontrado para tela cheia');
    return;
  }

  const el = element as any;

  if (el.requestFullscreen) {
    el.requestFullscreen();
  } else if (el.webkitRequestFullscreen) {
    el.webkitRequestFullscreen();
  } else if (el.msRequestFullscreen) {
    el.msRequestFullscreen();
  } else {
    console.warn('Tela cheia não é suportada neste navegador');
  }
};

/**
 * Hook personalizado para funcionalidade de tela cheia
 * @returns Função para entrar em tela cheia e ref do container
 */
export const useFullscreen = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  const enterFullscreen = () => {
    handleEnterFullscreen(containerRef.current);
  };

  return {
    containerRef,
    enterFullscreen
  };
};

// Para usar em componentes sem React hooks
export const createFullscreenHandler = (containerRef: React.RefObject<HTMLDivElement>) => {
  return () => handleEnterFullscreen(containerRef.current);
};